import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Translator from '../../../requests/apa/Translator';
import RequestManager from '../../../requests/RequestManager';
import ReminderCreate from '../../../requests/tasks/user/ReminderCreateTask';
import ReminderDelete from '../../../requests/tasks/user/ReminderDeleteTask';
import ReminderList from '../../../requests/tasks/user/ReminderListTask';
import OptionButtonEvent from './OptionButtonEvent';

import ReminderNotifications from '../../../utils/RemindersNotifications/ReminderNotifications';
import { UpdateMiniObserver } from '../../PersistentMiniEpg/MiniObserver';
import Metadata from '../../../requests/apa/Metadata';
import EpgPersistence from '../../../AAF/Nepg/EpgPersistence';
import { Dates } from '../../../packages/dates';
import * as EventOptionsUtils from '../EventOptionsUtils';
import Asset from '../../../requests/apa/Asset';

class ReminderEvent extends Component {
    constructor(props = {}) {
        super(props);

        this.state = {
            isReminder: false,
            reminderId: null,
        }

        this.handleClick = this.handleClick.bind(this);
        this.imageButton_reminder = Asset.get('playingLive_programFuture_option_button_reminder', '/images/ic_clock.png');
    }

    getEventId() {
        const { data: {
            id: eventId = '',
        } = {} } = this.props;
        
        return eventId;
    }

    getEventAlfId() {
        const { data: {
            event_alf_id: event_alf_id = '',
        } = {} } = this.props;
        
        return event_alf_id;
    }

    getEventType() {
        const { 
            data: {
                type,
            } = {} 
        } = this.props;

        if (type === '0' || !type) {
            return 'epg_serie';
        } else {
            return 'epg_event';
        }
    }

    getEventDate() {
        const { data: {
            date_begin = '',
        } = {} } = this.props;
        const dateBeginDates = EpgPersistence.needsOffset() ? new Dates().unix(date_begin).utcOffset(EpgPersistence.needsOffset(), false) : new Dates().unix(date_begin);
        
        return dateBeginDates.format('YYYYMMDDHHmmss');
    }

    getChannelId() {
        const { data: {
            channel_id = '',
        } = {} } = this.props;

        return channel_id;
    }

    getReminderId() {
        const { reminderId } = this.state;

        return reminderId
    }

    componentDidMount() {
        this.checkIsReminder();
    }

    resetReminderState() {
        this.setState({
            isReminder:false,
            reminderId: null
        });
    }

    async checkIsReminder() {
        const request = new ReminderList();

        try {
            const res = await RequestManager.addRequest(request);

            if (res && Array.isArray(res.response)) {
                ReminderNotifications.initReminders(res.response)
                const reminder = res.response.find( r => r.event_id === this.getEventId());
                
                if (reminder && reminder.id) {
                    this.setState({
                        isReminder: true, 
                        reminderId: reminder.id
                    });
                    return {
                        isReminder: true,
                        reminders: res.response
                    };
                }
            }

            this.resetReminderState();

            return {
                isReminder: false,
                reminders: null
            };
        } catch(err) {
            console.log('ReminderEvent checkIsReminder catch err',err);
            this.resetReminderState();

            return {
                isReminder: false,
                reminders: null
            };
        }
    }

    handleRequest() {
        const {
            sendMetric = () => {},
        } = this.props;
        let request;
        const { isReminder } = this.state;

        if (isReminder) {
            request = new ReminderDelete(this.getReminderId());
        } else {
            request = new ReminderCreate(
                this.getEventId(),
                this.getEventAlfId(),
                this.getEventDate(),
                this.getEventType(),
                this.getChannelId()
            );
        }
        sendMetric(this.getTitle());
        return RequestManager.addRequest(request);
    }

    setLastTouch(lasttouch) {
        const { setLastTouchReminder = () => {} } = this.props;
        
        if (lasttouch && lasttouch.reminder) {
            setLastTouchReminder(lasttouch.reminder);
        }
    }

    async handleClick() {
        const {
            handleClose = () => {},
            showToReminderNotification = () => {},
            showReminderRemovedNotification = () => {}
        } = this.props;

        try {
            const reminderId = this.getReminderId();
            const eventId = this.getEventId();
            const response = await this.handleRequest();

            this.setLastTouch(response && response.response.lasttouch && response.response.lasttouch);
            // after delete or add reminder we check the status with reminder list to ensure and doble check 
            const { isReminder, reminders } = await this.checkIsReminder();
            
            if (isReminder) {
                handleClose();
                ReminderNotifications.setReminders(
                    parseInt(Metadata.get('sentinel_reminders_interval', 30)),
                    false,
                    reminders
                );
                showToReminderNotification();
            } else {
                handleClose();
                ReminderNotifications.clearTimeoutReminder(reminderId);
                ReminderNotifications.clearReminderByEventId(eventId)
                ReminderNotifications.removeReminderFromList(reminderId);
                showReminderRemovedNotification();
            }

            UpdateMiniObserver.fire();
        } catch(err) {
            console.log('ReminderEvent handleClick catch err',err);
        }
    }

    getTitle() {
        const { isReminder } = this.state;
        let title;

        if (isReminder) {
            //TODO check metadata keys
            title = Translator.get('panelOptions_sidemenu_item_program_button_deleteReminder','Quitar recordatorio');
        } else {
            title = Translator.get('panelOptions_sidemenu_item_program_button_addReminder','Programar recordatorio');
        }

        return title;
    }

    render() {
        const title = this.getTitle();
        const {
            data = {},
            user = {}
        } = this.props;

        if (!EventOptionsUtils.hasEventReminderButton(data) || (user && user.isAnonymous)) {
            return null;
        }

        return (
            <OptionButtonEvent
                title = {title}
                onClick={this.handleClick}
                image={this.imageButton_reminder}
            />
        )
    }
}

ReminderEvent.propTypes = {
    setLastTouchReminder: PropTypes.func.isRequired,
    showToReminderNotification: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    sendMetric: PropTypes.func.isRequired,
    showReminderRemovedNotification: PropTypes.func.isRequired,
}

ReminderEvent.defaultProps = {
    setLastTouchReminder: () => {},
    showToReminderNotification: () => {},
    handleClose: () => {},
    data: {},
    sendMetric: () => {},
    showReminderRemovedNotification: () => {}
}

export default ReminderEvent;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/ReminderEvent.jsx